import React, {Component} from 'react';
import {auth} from '../../../firebase/index';
import {byPropKey} from "../../utils";
import {stringify} from "query-string";
import {prependQuestionMark} from "../../../utils/string";
import {PASSWORD_RESET_SUCCESS_EMAIL_SUCCESS} from "../../../constants/routes";
import {withRouter} from "react-router-dom";
import "./styles.css";
import {urlLogo} from "../../../constants/asseturls";

/**
 * Initial/ fallback state
 */
const INITIAL_STATE = {
    email: '',
    error: null
};

/**
 * The form component of the forget password page
 */
class ForgetPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE
        };
    }

    /**
     * Called when the form is submitted.
     * Executes a password reset to the supplied email.
     */
    onSubmit = (event) => {
        const email = this.state.email;
        const urlQuery = prependQuestionMark(stringify({to: email}));
        // 1. Attempt reset password using firebase API
        auth.doPasswordReset(email)
            .then(() => {
                // 2. Reset state
                this.setState(() => ({
                    ...INITIAL_STATE
                }));

                // 3. Reroute to successful password reset page
                this.props.history.push(PASSWORD_RESET_SUCCESS_EMAIL_SUCCESS + urlQuery);
            })
            .catch(error => {
                this.setState(byPropKey('error', error));
            });

        // Prevents the default reload of a browser which would otherwise be natural behaviour when submitting a form.
        event.preventDefault();
    };

    /**
     * @returns {boolean} {@code true} if the current state variables are
     * invalid and a password reset request should not be sent.
     */
    isInvalid = () => {
        // TODO: add more validation using regular expressions
        const emptyEmail = this.state.email === '';
        return emptyEmail;
    };

    render() {
        const isInvalid = this.isInvalid();

        return (
            <section className="forget-form">
                <form onSubmit={this.onSubmit}>
                    <img src={urlLogo} className="img-responsive" alt="" />
                    <p>Please enter the email of the account which you registered with:</p>
                    <input
                        className="form-control input-lg"
                        value={this.state.email}
                        onChange={event => this.setState(byPropKey('email', event.target.value))}
                        type="email"
                        placeholder="Email Address"
                    />
                    <button
                        className="btn btn-lg btn-primary btn-block"
                        disabled={isInvalid}
                        type="submit"
                    >
                        Reset Password
                    </button>

                    {
                        this.state.error &&
                        <p>
                            {this.state.error.message}
                        </p>
                    }
                </form>
            </section>
        );
    }
}

export default withRouter(ForgetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/auth/forgotpassword/ForgetPasswordForm.jsx